import {
  CalendarMonthOutlined,
  CheckCircleOutline,
  CancelOutlined,
  EditOutlined,
  PaidOutlined,
  ViewAgendaOutlined,
  DateRangeOutlined,
  TuneOutlined,
  MoneyOffOutlined,
  AccountBalanceWalletOutlined,
  ReceiptOutlined,
  HourglassEmptyOutlined,
} from "@mui/icons-material";
import type { SvgIconComponent } from "@mui/icons-material";
import { colors } from "../../../ui/colors";
import type { QuoteStatusFilter, TimeRangePreset, DepositFilter } from "./quote-filters.types";

/* ───── Generic option shape ───── */

export interface FilterOption<V extends string> {
  label: string;
  value: V;
  icon: SvgIconComponent;
}

/* ───── Color scheme (one per category) ───── */

export interface FilterColorScheme {
  activeBg: string;
  activeBorder: string;
  activeText: string;
  activeIcon: string;
  hoverBg: string;
  hoverBorder: string;
}

/* ───── Status ───── */

export const STATUS_FILTERS: readonly FilterOption<QuoteStatusFilter>[] = [
  { label: "All", value: "ALL", icon: ViewAgendaOutlined },
  { label: "Approved", value: "approved", icon: CheckCircleOutline },
  { label: "Declined", value: "declined", icon: CancelOutlined },
  { label: "Revision", value: "revision", icon: EditOutlined },
  { label: "Paid", value: "paid", icon: PaidOutlined },
];

export const STATUS_SCHEME: FilterColorScheme = {
  activeBg: colors.orange[100],
  activeBorder: colors.orange[200],
  activeText: colors.orange[700],
  activeIcon: colors.orange[500],
  hoverBg: colors.orange[50],
  hoverBorder: colors.orange[100],
};

/* ───── Time range ───── */

const CURRENT_MONTH = new Intl.DateTimeFormat("en-US", { month: "long" }).format(new Date());
const NEXT_MONTH = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
  new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1),
);

export const TIME_FILTERS: readonly FilterOption<TimeRangePreset>[] = [
  { label: "This Week", value: "THIS_WEEK", icon: DateRangeOutlined },
  { label: `This ${CURRENT_MONTH}`, value: "THIS_MONTH", icon: CalendarMonthOutlined },
  { label: `Next ${NEXT_MONTH}`, value: "NEXT_MONTH", icon: CalendarMonthOutlined },
  { label: "Custom", value: "CUSTOM", icon: TuneOutlined },
];

export const TIME_SCHEME: FilterColorScheme = {
  activeBg: colors.blue[50],
  activeBorder: colors.blue[200],
  activeText: colors.blue[700],
  activeIcon: colors.blue[500],
  hoverBg: colors.blue[50],
  hoverBorder: colors.blue[100],
};

/* ───── Deposit ───── */

export const DEPOSIT_FILTERS: readonly FilterOption<DepositFilter>[] = [
  { label: "Has Deposit", value: "HAS_DEPOSIT", icon: AccountBalanceWalletOutlined },
  { label: "No Deposit", value: "NO_DEPOSIT", icon: MoneyOffOutlined },
  { label: "Deposit Paid", value: "DEPOSIT_PAID", icon: ReceiptOutlined },
  { label: "Deposit Pending", value: "DEPOSIT_PENDING", icon: HourglassEmptyOutlined },
];

export const DEPOSIT_SCHEME: FilterColorScheme = {
  activeBg: colors.success[50],
  activeBorder: colors.success[200],
  activeText: colors.success[700],
  activeIcon: colors.success[500],
  hoverBg: colors.success[50],
  hoverBorder: colors.success[100],
};
